var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContractPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 43,
    viewBox: "0 0 34 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contract Payment"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contract Payment_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.1559 0.773438H5.60876C4.16017 0.774933 2.77132 1.35099 1.74693 2.37522C0.722535 3.39945 0.146258 4.7882 0.144531 6.2368V36.9308C0.146269 38.3794 0.72255 39.7682 1.74694 40.7924C2.77133 41.8166 4.16018 42.3927 5.60876 42.3942H27.9785C29.4269 42.3926 30.8156 41.8164 31.8399 40.7922C32.8641 39.768 33.4402 38.3793 33.4418 36.9308V12.2694L23.1559 0.773438ZM23.8753 5.48223L29.2292 11.4655H23.8753V5.48223ZM30.8386 36.9309C30.8377 37.6892 30.5361 38.4161 29.9999 38.9523C29.4638 39.4885 28.7368 39.7901 27.9785 39.7909H5.6088C4.8504 39.7902 4.12326 39.4886 3.58691 38.9524C3.05055 38.4163 2.74879 37.6892 2.74782 36.9308V6.23676C2.7488 5.47837 3.05056 4.75134 3.58691 4.21516C4.12325 3.67898 4.85038 3.37744 5.60876 3.37669H21.272V14.0686H30.8386V36.9309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.7111 18.1094H12.707V20.7126H24.7111V18.1094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.7111 24.1133H12.707V26.7165H24.7111V24.1133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.7092 29.8281H18.707V32.4314H24.7092V29.8281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.1952 18.1094H7.69922V20.7126H10.1952V18.1094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.1952 24.1133H7.69922V26.7165H10.1952V24.1133Z",
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractPayment);
export default __webpack_public_path__ + "static/media/ContractPayment.ae73e6ac844ea9e4e40e9a060980cdad.svg";
export { ForwardRef as ReactComponent };